import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class VendasVendedoresPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        // if (!stateAnte.visualizar && this.state.visualizar) {
        //     this.getListaRegistros();
        // }
    }

    // getListaRegistros = () => {
    //     this.setState({ carregando: true, listaRegistros: [] });

    //     const { buscaOrdem, buscaAno, buscaMes, buscaUsuario } = this.props.filtros;

    //     if ((buscaAno) || (buscaMes)) {

    //         axios
    //             .get('/vendas/listaMetasVendedores', {
    //                 params: {
    //                     print: true,
    //                     campoOrdem: buscaOrdem.campo,
    //                     tipoOrdem: buscaOrdem.ordem,
    //                     ano: buscaAno,
    //                     mes: buscaMes,
    //                     usuario: buscaUsuario.key,
    //                 }
    //             })
    //             .then(response => {
    //                 const { data } = response;
    //                 this.setState({
    //                     listaRegistros: response.data.dados,
    //                     carregando: false,
    //                 });
    //             })
    //             .catch(erro => {
    //                 console.warn(erro);
    //                 this.setState({
    //                     carregando: false,
    //                 });
    //             });
    //     } else {
    //         this.setState({
    //             listaRegistros: [],
    //             carregando: false,
    //         });
    //     }

    // };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };



    render() {
        const { carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                    width={1400}
                >
                    <div>
                        <div className="titulo">
                            Grade para Produção
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 40, textAlign: "left" }} >
                                <span style={{ fontWeight: "bold" }}>Período: </span>
                                <span>{this.props.filtros.buscaDataIni + ' à ' + this.props.filtros.buscaDataFim}</span>
                            </Col>
                        </Row>

                        <Row>
                            <div style={{ marginTop: 10 }}>
                                <Table
                                    pagination={false}
                                    loading={{
                                        spinning: carregando,
                                        tip: 'Carregando. Aguarde...',
                                        size: "large"
                                    }}
                                    bordered
                                    dataSource={this.props.listaRegistros}
                                    columns={this.props.columns}
                                    // scroll={{ x: 600 }}
                                    rowKey={(registro => registro.prod_descricao)}
                                />
                            </div>
                        </Row>

                    </div>
                </PrintModal>
            </span>
        );
    }
}

export default VendasVendedoresPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/VendasGradePrintModal.js